import React from 'react';

import { Icon, Pressable } from '@rbilabs/universal-components';
import { CloseButtonWrapper } from 'features/menu/components/product-detail/product-detail-flow/product-detail-close/styled';

import { t } from 'state/intl/translations';

interface IProductDetailClose {
  onDismiss: () => void;
  color?: string;
}

export const ProductDetailClose: React.FC<IProductDetailClose> = ({ onDismiss, color }) => {
  return (
    <CloseButtonWrapper>
      <Pressable onPress={onDismiss} accessibilityRole="button" accessibilityLabel={t('close')}>
        <Icon variant="cancel" color={color} />
      </Pressable>
    </CloseButtonWrapper>
  );
};
